/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{LRUCache as o}from"../../core/LRUCache.js";const e=new o(500);export{e as webStyleSymbolCache};
